import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Skeleton from '@pedidosya/web-fenix/system/Skeleton';
import CardContainer from '@components/CardContainer';

const Content = styled(CardContainer)`
  padding: 12px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: ${({ theme, paddingY }) => theme.spacing(paddingY)} 0;
`;

const ShimmerContainer = styled.div`
  margin: ${({ theme, marginY, marginX }) =>
    `${theme.spacing(marginY)} ${theme.spacing(marginX)}`};
`;

const NotesContainer = styled.div`
  gap: 4px;
  display: flex;
  flex-direction: column;
`;

const ShimmerNotesContent = styled(CardContainer)`
  gap: 16px;
  margin: ${({ theme }) => `${theme.spacing(6)} 0`};
`;

const ShimmerNotesCounter = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
`;

const CardShimmer = ({ paddingY }) => (
  <CardContainer>
    <Content paddingY={paddingY}>
      <Skeleton height="8" width="40" />
      <Skeleton height="8" width="36" />
    </Content>
  </CardContainer>
);

const NotesShimmer = () => (
  <NotesContainer>
    <Skeleton height="5" width="10" />
    <Skeleton height="5" width="8" />
    <ShimmerNotesContent direction="column">
      <Skeleton height="8" width="10" />
      <ShimmerNotesCounter>
        <Skeleton height="2" width="3" />
      </ShimmerNotesCounter>
    </ShimmerNotesContent>
  </NotesContainer>
);

function OptionsGroupShimmer() {
  return (
    <>
      <ShimmerContainer marginY={6} marginX={8}>
        <CardShimmer paddingY={7.5} />
      </ShimmerContainer>
      <ShimmerContainer marginY={6} marginX={8}>
        <CardShimmer paddingY={4} />
      </ShimmerContainer>
      <ShimmerContainer marginY={9} marginX={8}>
        <NotesShimmer />
      </ShimmerContainer>
    </>
  );
}

CardShimmer.propTypes = {
  paddingY: PropTypes.number,
};

export default OptionsGroupShimmer;
